"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _loadGoogleAnalytics = _interopRequireDefault(require("Components/Cookies/loadGoogleAnalytics"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @version 1.0.0
 *
 * @description chaque code doit être listé dans Stores/Cookistores
 * setCookiesParam doit être appelé quelque part (layout pour google analytics) avec le code correspondant à chaque évènement utile (changement de page pour analytics)
**/
var _default = exports.default = {
  google_analytics: {
    title: 'Google Analytics',
    description: 'Aspiejob recueille des données anonymes par défaut.<br />En activant cette fonctionnalité vous permettez un suivi plus pertinent lors de votre naviguation sur la plateforme.',
    load: _loadGoogleAnalytics.default,
    init: function () {
      const code = 'google_analytics';
      window.dataLayer ||= [];
      const keyword = (0, _utilities.isTrue)(window.localStorage.getItem('custom_consent_' + code)) ? 'granted' : 'denied';
      gtag('consent', 'default', {
        'analytics_storage': keyword,
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'wait_for_update': 500
      });
      gtag('js', new Date());
    },
    onAcceptation: function () {
      gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    },
    onDenied: function () {
      gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  }
};
function gtag() {
  (window.dataLayer || []).push(arguments);
}
